import type { ComponentType, SVGProps } from 'react';
import {
    ChatBubbleLeftRightIcon,
    ComputerDesktopIcon,
    EnvelopeIcon,
    PencilSquareIcon,
    PhoneIcon
} from '@heroicons/react/24/outline';
import type { CommunicationChannel } from '../../../../services/communications';

// Per-channel presentation + entry-field shape. `direction` is required
// except for 'note'; `duration` only applies to 'call'.
export interface ChannelDef {
    id: CommunicationChannel;
    label: string;
    icon: ComponentType<SVGProps<SVGSVGElement>>;
    tone: string;
    soft: string;
    hasDirection: boolean;
    hasDuration: boolean;
    /** Null hides the contact field entirely (e.g. 'note'). */
    contactLabel: string | null;
    contactPlaceholder: string | null;
    /** Null hides the contact-name field entirely (only 'note'). */
    contactNameLabel: string | null;
    contactNamePlaceholder: string | null;
}

export const CHANNELS: readonly ChannelDef[] = [
    {
        id: 'call',
        label: 'Call',
        icon: PhoneIcon,
        tone: '#2C6F67',
        soft: '#CAF2ED',
        hasDirection: true,
        hasDuration: true,
        contactLabel: 'Phone number',
        contactPlaceholder: '(000) 000-0000',
        contactNameLabel: 'Caller name',
        contactNamePlaceholder: "Who's on the phone?"
    },
    {
        id: 'text',
        label: 'Text',
        icon: ChatBubbleLeftRightIcon,
        tone: '#DB2777',
        soft: '#FCE7F3',
        hasDirection: true,
        hasDuration: false,
        contactLabel: 'Phone number',
        contactPlaceholder: '(000) 000-0000',
        contactNameLabel: 'Caller name',
        contactNamePlaceholder: 'Who texted in?'
    },
    {
        id: 'email',
        label: 'Email',
        icon: EnvelopeIcon,
        tone: '#3B82F6',
        soft: '#DBEAFE',
        hasDirection: true,
        hasDuration: false,
        contactLabel: 'Email address',
        contactPlaceholder: 'name@example.com',
        contactNameLabel: 'Name',
        contactNamePlaceholder: 'Who emailed?'
    },
    {
        id: 'dashboard',
        label: 'Dashboard',
        icon: ComputerDesktopIcon,
        tone: '#7C6BEA',
        soft: '#EDE9FE',
        hasDirection: true,
        hasDuration: false,
        contactLabel: null,
        contactPlaceholder: null,
        contactNameLabel: 'Name',
        contactNamePlaceholder: 'Who responded?'
    },
    {
        id: 'note',
        label: 'Note',
        icon: PencilSquareIcon,
        tone: '#6B7280',
        soft: '#F3F4F6',
        hasDirection: false,
        hasDuration: false,
        contactLabel: null,
        contactPlaceholder: null,
        contactNameLabel: null,
        contactNamePlaceholder: null
    }
];

export function channelDef(channel: CommunicationChannel): ChannelDef {
    return CHANNELS.find((c) => c.id === channel) ?? CHANNELS[0];
}
